/**
 * Comment threads of a `.zwdoc` document: `header.comments`, read and
 * rewritten without touching the body.
 */

import { readZwDocHeader, withZwDocHeader } from "../lib/zwdoc/format";
import type { CommentStore } from "../lib/zwdoc/comments";

export type {
  CommentMessage,
  CommentStore,
  CommentThread,
} from "../lib/zwdoc/comments";

/** Threads (`{}` when there are none or the header is unreadable). */
export function readCommentStore(doc: string): CommentStore {
  const header = readZwDocHeader(doc);
  return header.ok ? { ...header.value.comments } : {};
}

/** Replace the threads, leaving the body untouched (unreadable header: unchanged). */
export function writeCommentStore(doc: string, store: CommentStore): string {
  const header = readZwDocHeader(doc);
  if (header.ok === false) return doc;
  return withZwDocHeader(doc, { ...header.value, comments: store });
}
